import anniversaryImage from "@/assets/kv.png";
import heroImage from "@/assets/pc_kv.png";
import productImage from "@/assets/kv/product.png";
import softGlowImage from "@/assets/kv/kv_bg.png";

const createArticle = (id, title, link, image) => ({
	id,
	title,
	link,
	image,
});

export const FALLBACK_ARTICLES = Object.freeze({
	"10週年精選好文": [
		createArticle(
			"anniversary-01",
			"朵茉麗蔻來台10周年 抗老保養推薦「朵茉麗蔻全效8點3日份試用套組」熟齡必備保養品",
			"https://killer11312.pixnet.net/blog/post/50205436",
			anniversaryImage
		),
		createArticle(
			"anniversary-02",
			"來自日本(來台10週年)，讓我期待後又驚艷的抗老保養推薦",
			"https://asdfghjkl0905.pixnet.net/blog/post/50210704-%E3%80%90%E4%BF%9D%E9%A4%8A%E3%80%91%E4%BE%86%E8%87%AA%E6%97%A5%E6%9C%AC%28%E4%BE%86%E5%8F%B010%E9%80%B1%E5%B9%B4%29%EF%BC%8C%E8%AE%93%E6%88%91%E6%9C%9F%E5%BE%85%E5%BE%8C",
			heroImage
		),
		createArticle(
			"anniversary-03",
			"朵茉麗蔻全效8點3日份試用套組 X 來台10週年 X 抗老保養推薦",
			"https://kikio717.pixnet.net/blog/post/226233886",
			productImage
		),
		createArticle(
			"anniversary-04",
			"開箱朵茉麗蔻全效8點3日份試用套組。抗老保養推薦首選不要錯過！",
			"https://mimisa317.pixnet.net/blog/post/566916312",
			softGlowImage
		),
		createArticle(
			"anniversary-05",
			"朵茉麗蔻全效8點3日份試用套組 抗老保養推薦 來台10週年 好禮開箱",
			"https://missdebby790717.pixnet.net/blog/post/232402801",
			anniversaryImage
		),
	],
	"部落客好評推薦": [
		createArticle(
			"blogger-01",
			"評價 朵茉麗蔻全效8點三日份試用套組 推薦心得",
			"https://psvice.pixnet.net/blog/post/33259079",
			productImage
		),
		createArticle(
			"blogger-02",
			"恢復肌膚的根本力。朵茉麗蔻全效8點3日份試用套組 一試就愛上！",
			"https://wiwinnie.pixnet.net/blog/post/69753812",
			heroImage
		),
		createArticle(
			"blogger-03",
			"無懈可擊保養法 朵茉麗蔻全效8點跟我一起變漂亮",
			"https://weantiffany.pixnet.net/blog/post/69763086",
			softGlowImage
		),
		createArticle(
			"blogger-04",
			"朵茉麗蔻全效8點 - 熟齡肌的彈潤秘密武器！三日份試用套組心得",
			"https://eveshy.pixnet.net/blog/post/360059829",
			productImage
		),
		createArticle(
			"blogger-05",
			"天然與美麗的結合：朵茉麗蔻。熟齡美肌從肌底保養起",
			"https://beckysxsworld.pixnet.net/blog/post/467352083",
			heroImage
		),
	],
	"PIXNET網友口碑推薦": [
		createArticle(
			"netizen-01",
			"持續使用超有感 Domohorn Wrinkle 朵茉麗蔻基本四點回復肌膚活力",
			"https://cecile0982.pixnet.net/blog/posts/7108090265",
			anniversaryImage
		),
		createArticle(
			"netizen-02",
			"Domohorn Wrinkle朵茉麗蔻試用",
			"https://phoebe93.pixnet.net/blog/posts/8193322613",
			productImage
		),
		createArticle(
			"netizen-03",
			"Domohorn Wrinkle朵茉麗蔻 全效8點三日份試用套組華麗進化升級版體驗心得",
			"https://cheryllooo.pixnet.net/blog/post/360704726-%5B-beauty-%5D-%E6%9C%B5%E8%8C%89%E9%BA%97%E8%94%BB",
			softGlowImage
		),
		createArticle(
			"netizen-04",
			"Domohorn Wrinkle朵茉麗蔻 全效8點3日份試用套組 來台10周年，感恩好禮",
			"https://babybrown.pixnet.net/blog/post/50202512",
			heroImage
		),
		createArticle(
			"netizen-05",
			"保養│朵茉麗蔻3日份試用套組，在家就能輕鬆體驗來自日本透亮美肌的逆齡保養",
			"https://sammi0224.pixnet.net/blog/post/118465530",
			productImage
		),
	],
	"精選文章": [
		createArticle(
			"selected-01",
			"提升肌膚根本力對抗各種衰老！朵茉麗蔻 全效8點，打造理想膚質",
			"https://wiwinnie.pixnet.net/blog/post/70442529",
			heroImage
		),
		createArticle(
			"selected-02",
			"全膚質適用~Domohorn Wrinkle朵茉麗蔻 美活肌精華",
			"https://abbaco.pixnet.net/blog/posts/47579347",
			softGlowImage
		),
		createArticle(
			"selected-03",
			"Domohorn Wrinkle朵茉麗蔻 美活肌精華-透亮白皙由內煥發(全成分分析)",
			"https://w20770.pixnet.net/blog/posts/3038168421",
			productImage
		),
		createArticle(
			"selected-04",
			"抗老保養」朵茉麗蔻 全效8點3日份試用套組開箱～慶祝來台10週年優惠好禮組",
			"https://milktea1060.pixnet.net/blog/post/363790606-%E3%80%8C%E6%8A%97%E8%80%81%E4%BF%9D%E9%A4%8A%E3%80%8D%E6%9C%B5%E8%8C%89%E9%BA%97%E5%AF%87-%E5%85%A8%E6%95%888%E9%BB%9E%E8%A9%A6%E7%94%A8%E5%A5%97%E7%B5%84%E9%96%8B%E7%AE%B1",
			anniversaryImage
		),
	],
});

export const getArticlesByTag = (tagName) => FALLBACK_ARTICLES[tagName] || [];
